import moment from "moment";
import { DatePicker } from "../../../../utils/form";

const BirthDateInput = props => {
  return <DatePicker {...props} name="birthDate" label="Fecha de nac." maxDate={moment()} required />
};

export default BirthDateInput;
